import { useNavigate } from 'react-router-dom'
import { useState } from 'react'

import {
  BackBtnProps,
  EngagementPlaceholderProps,
  HomeBtnProps,
  LinksProps,
  ScanBtnProps,
  SocialModalProps,
} from '../../../types/props'
import BackBtn from './BackBtn'
import Header from './Header'
import Links from './Links'
import SocialModal from './SocialModal'
import ScanBtn from './ScanBtn'
import HomeBtn from './HomeBtn'
import '../Brand.scss'
import config from '../../../config'
import usePosthogEvent from '../../../hooks/use-posthog-event'

const Placeholder = ({
  handleBackClick,
  setYoutubeOpen,
  isYoutubeOpen,
  setBrochureOpen,
  isBrochureOpen,
  brandEngagement,
  productId,
  uniqueId,
  hideCta,
  isLiveStream,
}: EngagementPlaceholderProps) => {
  const [isModalOpen, setModal] = useState(false)
  const navigate = useNavigate()
  const posthogEvent = usePosthogEvent()

  const toggle = () => setModal(!isModalOpen)

  const backBtnProps: BackBtnProps = {
    handleBackClick,
  }

  const isSDK = brandEngagement?.sdk_version === 'V1' || brandEngagement?.sdk_version == 'V2'

  const handleScanAgainClick = () => {
    posthogEvent.sendScanAgainClickedEvent({ screenName: 'Brand Engagement' })
    const customUrl = brandEngagement?.button?.scanAgainBtn?.url
    const customRedirect = brandEngagement?.button?.scanAgainBtn?.redirectUrl
    if (customUrl)
      navigate(customUrl, {
        state: {
          productId,
          brandEngagement,
        },
      })
    else if (customRedirect) window.location.href = customRedirect
    else if (productId) {
      const isSerDemo = !!uniqueId && productId === config.SER_DEMO
      const navigateUrl = isSerDemo
        ? `/product/id/${productId}/${uniqueId}`
        : `/product/id/${productId}`

      // TODO: refactor this code block
      isSDK ? navigate(navigateUrl) : (window.location.href = navigateUrl)
    } else navigate('/discover')
  }

  const handleHomeClick = () => {
    posthogEvent.sendHomeClickedEvent({ screenName: 'Brand Engagement' })
    const customUrl = brandEngagement?.button?.homeBtn?.url
    const customRedirect = brandEngagement?.button?.homeBtn?.redirectUrl

    if (customUrl)
      navigate(customUrl, {
        state: {
          productId,
          brandEngagement,
        },
      })
    else if (customRedirect) window.location.href = customRedirect
    else if (isSDK) navigate(`/product/id/${productId}`)
    else navigate('/discover')
  }

  const scanBtnProps: ScanBtnProps = {
    switchPage: handleScanAgainClick,
    brandEngagement,
  }

  const linksProps: LinksProps = {
    isYoutubeOpen,
    setYoutubeOpen,
    setBrochureOpen,
    isBrochureOpen,
    setModalOpen: setModal,
    brandEngagement,
    isLiveStream,
  }

  const socialModalProps: SocialModalProps = {
    isModalOpen,
    toggle,
    brandEngagement,
    isLiveStream,
  }

  const homeBtnProps: HomeBtnProps = {
    switchPage: handleHomeClick,
    brandEngagement,
  }
  return (
    <div className='engagement v1-engagement text-center'>
      <SocialModal {...socialModalProps} />
      <div className='v1-engagement__heading'>
        {(isYoutubeOpen || isBrochureOpen) && <BackBtn {...backBtnProps} />}
        <Header
          style={brandEngagement?.page?.brandLogo?.style || { width: '70%' }}
          image={brandEngagement?.page?.brandLogo?.img}
        />
      </div>
      <Links {...linksProps} />
      {!(isYoutubeOpen || isBrochureOpen) && !hideCta && (
        <div className='engagement-btn-group v1-engagement__btn-group'>
          <ScanBtn {...scanBtnProps} />
          <HomeBtn {...homeBtnProps} />
        </div>
      )}
    </div>
  )
}

export default Placeholder
